import React, { Component } from 'react'
import styled from 'styled-components'
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'react-mdl'
import Button from '../../components/Button'
import { IconButton } from 'react-mdl'

const Input = styled.input`
  width: 90%;
  padding: 0;
  box-sizing: border-box;
`

export default class UnitElementModal extends Component {
  state = { element: this.props.element }
  handleSave = () => {
    this.props.onChange(this.state.element)
    this.props.onClose()
  }
  onChangeText = ({ target }) =>
    this.setState(({ element }) => ({
      element: { ...element, text: target.value },
    }))
  onChangeTextItem = i => ({ target }) =>
    this.setState(({ element }) => ({
      element: {
        ...element,
        items: [
          ...element.items.slice(0, i),
          { ...element.items[i], text: target.value },
          ...element.items.slice(i + 1),
        ],
      },
    }))
  onChangeTextSubitem = (i, j) => ({ target }) =>
    this.setState(({ element }) => ({
      element: {
        ...element,
        items: [
          ...element.items.slice(0, i),
          {
            ...element.items[i],
            items: [
              ...element.items[i].items.slice(0, j),
              target.value,
              ...element.items[i].items.slice(j + 1),
            ],
          },
          ...element.items.slice(i + 1),
        ],
      },
    }))
  addItem = () =>
    this.setState(({ element }) => {
      const items = [...(element.items || []), { text: '', items: [] }]
      return { element: { ...element, items } }
    })
  addSubitem = i => () =>
    this.setState(({ element }) => {
      const subitems = [...(element.items[i].items || []), '']
      const item = { ...element.items[i], items: subitems }
      const items = [
        ...element.items.slice(0, i),
        item,
        ...element.items.slice(i + 1),
      ]
      return { element: { ...element, items } }
    })
  deleteItem = (i, j) => {
    this.setState(({ element }) => {
      const items =
        j != null
          ? [
              ...element.items.slice(0, i),
              {
                ...element.items[i],
                items: [
                  ...element.items[i].items.slice(0, j),
                  ...element.items[i].items.slice(j + 1),
                ],
              },
              ...element.items.slice(i + 1),
            ]
          : [...element.items.slice(0, i), ...element.items.slice(i + 1)]
      return { element: { ...element, items } }
    })
  }
  render() {
    const { element } = this.state
    if (!element) return null
    return (
      <Dialog open style={{ width: 850 }}>
        <DialogTitle>Edit Unit Element</DialogTitle>
        <DialogContent>
          <Input value={element.text} onChange={this.onChangeText} />
          {element.items &&
            element.items.length > 0 &&
            <ul>
              {element.items.map(({ text, items = [] }, i) =>
                <li key={i}>
                  <Input value={text} onChange={this.onChangeTextItem(i)} />
                  <IconButton
                    colored
                    accent
                    name="delete"
                    onClick={() => this.deleteItem(i)}
                    type="button"
                  />
                  {items &&
                    items.length > 0 &&
                    <ul>
                      {items.map((text, j) =>
                        <li key={j}>
                          <Input
                            value={text}
                            onChange={this.onChangeTextSubitem(i, j)}
                          />
                          <IconButton
                            colored
                            accent
                            name="delete"
                            onClick={() => this.deleteItem(i, j)}
                            type="button"
                          />
                        </li>,
                      )}
                    </ul>}
                  <Button type="button" onClick={this.addSubitem(i)}>
                    Add Subitem
                  </Button>
                </li>,
              )}
            </ul>}
          <Button type="button" onClick={this.addItem}>
            Add Item
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.onClose()}>Cancel</Button>
          <Button onClick={this.handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Units/CreateUnit/UnitElementModal.js